import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/styles'
import Logo from '../../../svg/Logo'

/**
 * Renders the photobucket logo for non mobile devices
 */
export default function StyledFormPBLogo() {
  const theme = useTheme()
  const isDeviceMobileSized = useMediaQuery(theme.breakpoints.only('xs'))

  // hides on mobile phones to save screen real-estate
  if (isDeviceMobileSized) {
    return null
  }

  return <Logo width="200px" />
}
